import { render, staticRenderFns } from "./SuperBomComponentWidthList.vue?vue&type=template&id=382eda2c&scoped=true"
import script from "./SuperBomComponentWidthList.vue?vue&type=script&lang=js"
export * from "./SuperBomComponentWidthList.vue?vue&type=script&lang=js"
import style0 from "./SuperBomComponentWidthList.vue?vue&type=style&index=0&id=382eda2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382eda2c",
  null
  
)

export default component.exports